import { axios } from '@Api/axiosClient';
import type { KbaUserInfo, KbaQuestionSet, KbaSendAnswersRequest, KbaAnswersResponse } from '@Types/kba.types';

export const getKbaQuestionsApi = async (userInfo: KbaUserInfo): Promise<KbaQuestionSet> => {
    const response = await axios.post('/api/Kba/GetQuestions', userInfo);
    return response.data;
};

export const sendKbaAnswersApi = async (request: KbaSendAnswersRequest): Promise<KbaAnswersResponse> => {
    const response = await axios.post('/api/Kba/SendAnswers', request);
    return response.data;
};
